import axiosInstance from "./AxiosInstanceMain";

export const getFbFormsApi = async (params) => {
  const res = await axiosInstance.get("/admin/fb-leadgen/forms", { params });
  return res.data;
};

export const updateFbFormStatusApi = async (id, data) => {
  const res = await axiosInstance.put(`/admin/fb-leadgen/forms/${id}/status`, data);
  return res.data;
};